/** @default 'base64' */
export type Base64Alphabet = 'base64' | 'base64url'
